export { default } from './BrowserGuard';
